import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhproductFilterCriteria from './PhproductFilterCriteria'
import PhproductList from './PhproductList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhproductAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhproductDashboardPhproductList } from '../../store/slice/PharmaSlice';

export default function PhproductListView({setShowEdit,setPhproductId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phproductDashboard);   

    const [filteredPhproductList, setFilteredPhproductList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phproductDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phproductDashboard.phproductList.length>-1){
        setFilteredPhproductList(phproductDashboard.phproductList);
        transformToCardFormat(phproductDashboard.phproductList, setCardList);
      }
    },[phproductDashboard.phproductList])

    useEffect(()=>{
          transformToCardFormat(filteredPhproductList, setCardList);
      },[filteredPhproductList])

    useEffect(()=>{
        if (filterCriteria.partyname==='' && filterCriteria.title==='' && filterCriteria.status==='' && filterCriteria.boxesrequired==='' && filterCriteria.form==='' && filterCriteria.packagingmaterial==='' ){
            setFilteredPhproductList(phproductDashboard.phproductList);
            transformToCardFormat(phproductDashboard.phproductList, setCardList);

        } else {
            setFilteredPhproductList(
                phproductDashboard.phproductList
                    .filter(phproduct=> phproduct.partyname.toString().toUpperCase().includes(filterCriteria.partyname.toString().toUpperCase()))
.filter(phproduct=> phproduct.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(phproduct=> phproduct.status.toString().toUpperCase().includes(filterCriteria.status.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(phproductDashboard.filteredPhproductList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhproductList
                    setShowEdit={setShowEdit}
                    setPhproductId = {setPhproductId}
                    tableList={filteredPhproductList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}